import React from 'react';
import { Chat as ChatIcon } from '@mui/icons-material';
import type { EmployeeMessage } from '@shared/types';
import {
    ChatMessageList,
    ChatComposer,
} from '@features/requests/components/RequestChat/components';
import styles from './RequestChat.module.css';

/**
 * Props for RequestChat component
 */
export interface RequestChatProps {
    /** List of messages to display */
    messages: EmployeeMessage[];
    /**
     * Callback when sending a message.
     * Return `false` to keep the text in the composer (send failed).
     */
    onSend: (text: string) => Promise<boolean | void> | boolean | void;
    /** Whether a send is currently in progress */
    isSending?: boolean;
    /** Whether messages are loading */
    isLoading?: boolean;
}

/**
 * Renders the full request chat view with header, message list, and composer
 */
export const RequestChat = React.memo(function RequestChat({
    messages,
    onSend,
    isSending = false,
    isLoading = false,
}: RequestChatProps): React.ReactElement {
    return (
        <div
            className={styles.container}
            data-testid="request-chat"
        >
            <div className={styles.header}>
                <ChatIcon fontSize="small" />
                <h2 className={styles.title}>Meldinger</h2>
            </div>
            <div className={styles.messages}>
                <ChatMessageList
                    messages={messages}
                    isLoading={isLoading}
                />
            </div>
            <ChatComposer
                onSend={onSend}
                isSending={isSending}
            />
        </div>
    );
});
